<template>
    <div>
        
        <div class="container" v-if="status === 'pending'">

        </div>

        <div class="eta">
            <div class="img">
                <img src="https://assets.friendlydiamonds.com/fdl/fd_gif/shipment.gif" width="35" height="35" alt="estimate shipment">
            </div>
            
            <p class="mb-0" v-if="etaData">
                <strong> {{ $country.estimate_msg }} &nbsp;</strong> 
                <span> {{ etaData.data.eta }}</span>
            </p>
            <!-- Otherwise, show NA -->
            <p class="mb-0" v-else>
                <strong> {{ $country.estimate_msg }}</strong> 
                <span> NA</span>
            </p>
        </div>
    </div>
    
</template>

<script setup>

    // ALWYAS Y+USE IN BELOW MANNER
    // reactivity will be intact -> module_subtype   

    const props  = defineProps(['module_subtype', 'setting_id','diamond_id', 'size'])
    const { module_subtype, setting_id, diamond_id, size } = toRefs(props)
    const status = ref('pending'); 
    // Watchers for setting_id and size
    
    const type = ref('')

    const etaData = ref(false)
   
    
    if(['ring', 'loose'].includes(module_subtype.value)){

        type.value = 'cyor'
    }
    else if(module_subtype.value == 'pendant'){

        type.value = 'cyop'
    }
    else if(module_subtype.value == 'earring'){

        type.value = 'cyoe'
    }
    else if(module_subtype.value == 'preset'){

        type.value = 'preset'
    }
    else{
        type.value = 'shop'
    }

    

    onMounted(() => {

        watchEffect(() => {
            
            status.value = 'pending';
            
            const url = useCountryPath(`/setting/${type.value}/eta?sid=${setting_id.value}&did=${diamond_id.value}&size=${size.value}`)
            try {
                $fetch(url).then( (res) => {
                    if (res?.data?.eta) {
                        etaData.value = res;
                        status.value = 'success';  
    
                    }
                });
            } catch (error) {
                console.error('Error fetching ETA data:', error);
                status.value = 'error';

            }

        })
    });

</script>

<style scoped>
/* //444444444444444 */
.eta {
    display: flex;
    align-items: center;
    background: #f5f5f5;
    padding: 0 12px;
    height: 68px;
    border-radius: 8px;
    position: relative;
}
.eta p {
    color: #353535;
    font-size: 16px;
    font-weight: 400;
    margin-left: 6px;
    padding-top: 3px;
}

.eta span {
    color: var(--green);
    font-weight: 600;
}
@media(max-width: 767px){
    .eta p{
        font-size: 14px;
    }
    .eta p span {
        /* display: block; */
    }
    .eta{
        display: flex;
        align-items: center;
        padding:7px;
        height: auto;
        border-radius: 8px;
    }
}
</style>